var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 2000 2500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1380.33 1520.01L1455.96 1466.58C1477.63 1451.26 1481.73 1422.84 1464.64 1403L1405.67 1334.48C1388.77 1314.85 1357.41 1311.13 1335.5 1326.61L1259.88 1380.04C1238.2 1395.36 1234.11 1423.78 1251.19 1443.62L1310.16 1512.14C1327.48 1531.82 1358.66 1535.31 1380.33 1520.01Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1365.41 1514.9L1452.93 1461.52C1478.01 1446.21 1484.91 1415.32 1467.85 1392.35L1408.94 1313.06C1392.06 1290.34 1357.96 1284.09 1332.62 1299.55L1245.11 1352.92C1220.03 1368.23 1213.13 1399.13 1230.2 1422.1L1289.1 1501.39C1306.41 1524.17 1340.33 1530.18 1365.41 1514.9Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1348.98 1510.42L1449.52 1457.93C1478.33 1442.88 1488.52 1409.45 1471.75 1383.07L1413.82 1291.97C1397.22 1265.88 1360.33 1256.64 1331.2 1271.84L1230.66 1324.32C1201.83 1339.38 1191.66 1372.8 1208.44 1399.19L1266.35 1490.28C1283.44 1516.5 1320.17 1525.45 1348.98 1510.42Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1330.83 1506.56L1445.61 1455.96C1478.5 1441.45 1492.52 1405.48 1476.34 1375.36L1420.49 1271.36C1404.48 1241.57 1364.78 1228.87 1331.54 1243.53L1216.77 1294.12C1183.86 1308.64 1169.86 1344.61 1186.04 1374.73L1241.87 1478.72C1258.4 1508.67 1297.94 1521.05 1330.83 1506.56Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1310.75 1503.24L1440.98 1455.7C1478.31 1442.06 1496.72 1403.56 1481.53 1369.38L1429.06 1251.38C1414.03 1217.57 1371.53 1200.88 1333.82 1214.65L1203.59 1262.2C1166.26 1275.83 1147.84 1314.33 1163.04 1348.51L1215.49 1466.51C1231.09 1500.53 1273.42 1516.85 1310.75 1503.24Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1288.49 1500.39L1435.43 1457.28C1477.55 1444.9 1501.01 1403.94 1487.24 1365.38L1439.65 1232.25C1426.02 1194.11 1380.81 1172.84 1338.24 1185.33L1191.32 1228.45C1149.2 1240.82 1125.73 1281.78 1139.51 1320.34L1187.08 1453.46C1201.32 1491.88 1246.38 1512.73 1288.49 1500.39Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.81 1497.9L1428.7 1460.8C1475.96 1450.15 1505.18 1406.83 1493.33 1363.57L1452.4 1214.18C1440.67 1171.38 1392.84 1144.9 1345.09 1155.63L1180.2 1192.73C1132.93 1203.38 1103.72 1246.7 1115.57 1289.96L1156.51 1439.35C1168.88 1482.49 1216.57 1508.52 1263.81 1497.9Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.46 1495.64L1420.53 1466.39C1473.29 1458 1509.03 1412.5 1499.68 1364.19L1467.4 1197.42C1458.14 1149.63 1407.92 1117.24 1354.62 1125.72L1170.55 1154.96C1117.77 1163.35 1082.05 1208.86 1091.4 1257.16L1123.66 1423.94C1133.58 1472.14 1183.72 1504 1236.46 1495.64Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.13 1493.43L1410.59 1474.14C1469.21 1468.59 1512.27 1421.14 1506.11 1367.49L1484.81 1182.23C1478.71 1129.16 1426.35 1090.13 1367.13 1095.71L1162.66 1115.01C1104.05 1120.55 1060.98 1168 1067.16 1221.66L1088.45 1406.9C1095.24 1460.5 1147.55 1498.95 1206.13 1493.43Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.54 1491.11L1398.55 1484.15C1463.33 1482.13 1514.6 1433.06 1512.38 1373.76L1504.71 1168.99C1502.49 1110.33 1448.34 1063.86 1382.89 1065.87L1156.9 1072.83C1092.11 1074.84 1040.84 1123.91 1043.06 1183.22L1050.72 1387.98C1053.66 1447.24 1107.79 1493.08 1172.54 1491.11Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1135.39 1488.39L1383.98 1496.47C1455.23 1498.77 1515.66 1448.48 1518.24 1383.26L1527.17 1158.04C1529.71 1093.51 1474.23 1038.75 1402.23 1036.41L1153.65 1028.33C1082.39 1026.03 1021.96 1076.32 1019.38 1141.54L1010.45 1366.76C1008.65 1432 1064.17 1486.06 1135.39 1488.39Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.36 1485.02L1366.46 1511.16C1444.46 1518.63 1515.02 1467.66 1523.38 1396.26L1552.25 1149.74C1560.49 1079.11 1504.25 1015.17 1425.46 1007.59L1153.37 981.443C1075.36 973.963 1004.81 1024.94 996.443 1096.34L967.566 1342.85C960.056 1414.32 1016.41 1477.5 1094.36 1485.02Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1049.13 1480.64L1345.48 1528.25C1430.44 1541.88 1512.18 1490.84 1527.4 1413.08L1579.95 1144.58C1594.99 1067.65 1538.68 993.567 1452.85 979.776L1156.5 932.172C1071.53 918.549 989.79 969.58 974.58 1047.34L922.016 1315.85C907.733 1393.73 964.225 1466.98 1049.13 1480.64Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M999.355 1474.89L1320.51 1547.73C1412.59 1568.59 1506.61 1518.27 1529.9 1434L1610.31 1143.02C1633.33 1059.65 1577.82 974.447 1484.79 953.349L1163.63 880.512C1071.55 859.65 977.54 909.97 954.254 994.245L873.84 1285.23C851.561 1369.68 907.343 1453.99 999.355 1474.89Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M944.735 1467.28L1290.99 1569.55C1390.26 1598.84 1497.69 1550.16 1530.38 1459.3L1643.27 1145.59C1675.58 1055.7 1621.88 958.347 1521.6 928.726L1175.36 826.469C1076.09 797.173 968.661 845.857 935.968 936.716L823.082 1250.42C791.469 1341.58 845.544 1437.96 944.735 1467.28Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M884.939 1457.33L1256.22 1593.63C1362.67 1632.66 1484.67 1586.72 1528.25 1489.29L1678.69 1152.9C1721.77 1056.51 1671.08 945.952 1563.55 906.48L1192.27 770.198C1085.82 731.151 963.803 777.103 920.238 874.532L769.8 1210.91C727.403 1308.73 778.572 1418.27 884.939 1457.33Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M819.668 1444.44L1215.55 1619.81C1329.05 1670.04 1466.82 1628.11 1522.88 1524.23L1716.45 1165.56C1771.89 1062.79 1725.63 937.939 1610.97 887.153L1215.09 711.795C1101.59 661.551 963.82 703.482 907.766 807.369L714.197 1166.03C659.384 1270.43 706.256 1394.17 819.668 1444.44Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M748.639 1427.94L1168.2 1647.89C1288.49 1710.91 1443.22 1674.46 1513.53 1564.38L1756.31 1184.25C1825.83 1075.32 1785.66 935.111 1664.15 871.41L1244.59 651.463C1124.3 588.431 969.572 624.879 899.262 734.976L656.479 1115.1C587.492 1225.85 628.442 1364.89 748.639 1427.94Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M671.594 1407.08L1113.35 1677.61C1240.01 1755.13 1412.89 1725.9 1499.37 1609.98L1797.97 1209.75C1883.49 1095.06 1851.28 938.414 1723.34 860.064L1281.58 589.544C1154.9 512.021 982.039 541.252 895.562 657.175L596.964 1057.4C511.877 1174.12 545.047 1329.54 671.594 1407.08Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M588.308 1381.02L1050.15 1708.59C1182.58 1802.45 1374.76 1782.4 1479.46 1661.22L1841.01 1242.79C1944.57 1122.88 1922.49 948.745 1788.74 853.883L1326.9 526.328C1194.48 432.451 1002.29 452.51 897.59 573.705L536.028 992.127C432.782 1114.29 456.017 1287.15 588.308 1381.02Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M498.64 1348.82L977.691 1740.38C1115.05 1852.58 1327.64 1843.94 1452.79 1718.24L1884.97 1284.22C2008.76 1159.85 1999.27 967.237 1860.54 853.834L1381.5 462.288C1244.13 350.074 1031.56 358.721 906.399 484.425L474.211 918.424C350.558 1045.32 361.424 1236.62 498.64 1348.82Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M402.479 1309.45L894.977 1772.41C1036.21 1905.09 1270.2 1910.37 1418.2 1781.15L1929.19 1334.95C2075.56 1207.08 2081.46 995.061 1938.83 860.973L1446.31 398.027C1305.09 265.335 1071.08 260.045 923.096 389.288L412.092 835.48C265.692 966.118 261.405 1176.78 402.479 1309.45Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M299.778 1261.75L801.004 1804C944.738 1959.41 1201.06 1981.48 1374.41 1849.97L1972.93 1395.86C2144.37 1265.71 2168.8 1033.47 2023.65 876.432L1522.42 334.186C1378.68 178.761 1122.37 156.689 949.019 288.22L350.501 742.321C178.763 875.491 156.222 1106.35 299.778 1261.75Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M190.648 1204.45L694.732 1834.33C839.298 2014.86 1118.7 2056.89 1320.04 1924.63L2015.26 1467.94C2214.41 1337.05 2260.9 1083.91 2114.91 901.479L1610.82 271.613C1466.25 91.0783 1186.86 49.0293 985.517 181.315L290.291 637.995C90.5569 772.192 46.2661 1023.96 190.648 1204.45Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M75.2414 1136.19L575.038 1862.41C718.386 2070.55 1021.41 2136.1 1253.56 2004.96L2055.11 1552.16C2284.74 1422.38 2357.19 1147.83 2212.44 937.504L1712.64 211.301C1569.29 3.13747 1266.27 -62.412 1034.12 68.7431L232.561 521.53C2.02922 654.9 -67.8913 928.087 75.2414 1136.19Z",
    stroke: "#2251FF",
    strokeWidth: 1.85656,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupDark);
export default __webpack_public_path__ + "static/media/Group_Dark.0026b60ac77078f1e91f73cfce405dbb.svg";
export { ForwardRef as ReactComponent };